import AttachmentHeaders from "./AttachmentHeadersContainer";

export default AttachmentHeaders;
